import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M33.976 51H5V36.42C5 32.14 7.299 30 11.897 30h40.206C56.701 30 59 32.14 59 36.42V51H33.976z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 17,
				cy: 41,
				r: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 48,
				cy: 41,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", { d: "M9 30.5a653.125 653.125 0 0 1 4.059-9.654C15.815 14.452 16.44 13 22.529 13H41.47c6.089 0 6.715 1.452 9.471 7.846 1.225 2.842 2.412 6.06 3.559 9.654" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M51 51v7.02M14 51v7.02",
				strokeLinecap: "square"
			})
		]
	})
});
export default SvgCarinline;
